// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2g701","content":"styles_content__1Y360","row":"styles_row__1LS_u","footer":"styles_footer__35s4P","phraseLength":"styles_phraseLength__tzkCw"};